/** Thirty inclusive UTC calendar days ending on the payment's creation date. */
export function transactionAnalysisPeriod(createdAt: string | number | null | undefined): { from: string; to: string } | undefined {
	if (createdAt == null || createdAt === "") return undefined;
	const value = typeof createdAt === "number" ? (createdAt < 1e12 ? createdAt * 1000 : createdAt)
		: /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(createdAt) ? `${createdAt.replace(" ", "T")}Z` : createdAt;
	const date = new Date(value);
	if (!Number.isFinite(date.getTime())) return undefined;
	const end = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
	return { from: new Date(end - 29 * 86400000).toISOString().slice(0, 10), to: new Date(end).toISOString().slice(0, 10) };
}
